import { getCurrentInstance } from '@tarojs/taro';
import { Component } from 'react';
import { Provider } from 'mobx-react'
import tracker from '@weus/joyweb-tracker';
import Cookies from 'js-cookie';
import { webLogConfig } from '@/utils/tracker';
import 'taro-ui/dist/style/index.scss';
import store from '@/store/index';
import { beforeMount } from "./utils/common-main";
import './app.less';
// 在 Taro Next 中，没有 组件的外部样式和全局样式 的概念，组件的配置（config.js）是无效的，页面和入口文件引入的 CSS 都会变成全局 CSS ，没有了 externalClasses 和 addGlobalClass 这两个概念。

// 储存url参数
const params = {}
class App extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    const { tenantid, tenantenid, token } = getCurrentInstance().router.params
    params.tenantid = tenantid || -1,
    params.tenantenid = tenantenid || -1,
    params.token = token || -1
  }
  async componentDidMount() {
    await beforeMount();
    // 测试环境下，如果是H5端，将token作为pin种在cookie里面，模拟已登录情况
    if (process.env.TARO_ENV === 'h5') {
      const { token } = getCurrentInstance().router.params;
      token && Cookies.set('temp_ffp_pin', token);
    }
    // 埋点初始化
    tracker.config(webLogConfig);
  }
  render() {
    return <Provider store={store} >{this.props.children}</Provider>
  }
}

export default App
